// Ordering for the /groups list (client 2026-10-12): groups you own first,
// then groups you've joined, then every other public group. Each row carries
// a `relation` so the row knows which action to offer (invite / leave / join).

const RANK = { owner: 0, member: 1, other: 2 }

export function groupRelation(group) {
  if (group.role === 'owner') return 'owner'
  if (group.role || group.is_member) return 'member'
  return 'other'
}

// myGroups: get_groups({ p_user_id }) rows (carry `role`).
// publicGroups: get_groups({ p_include_public }) rows (carry `is_member`),
// already filtered by the search term on the server.
export function buildGroupList(myGroups, publicGroups, searchTerm = '') {
  const term = (searchTerm || '').trim().toLowerCase()
  const mine = (myGroups || [])
    .filter((g) => !term || (g.name || '').toLowerCase().includes(term))
    .map((g) => ({ ...g, mine: true, relation: groupRelation(g) }))
  const mineIds = new Set((myGroups || []).map((g) => g.id))
  const others = (publicGroups || [])
    .filter((g) => !mineIds.has(g.id))
    .map((g) => ({ ...g, mine: false, relation: groupRelation(g) }))
  // Stable sort: inside each band the server's order (name for yours,
  // size for public) is kept.
  return [...mine, ...others].sort((a, b) => RANK[a.relation] - RANK[b.relation])
}

// Matches the group page: an owner can share the invite link unless the
// group is invite-closed (is_public = false).
export function canInviteFromList(group) {
  return group.relation === 'owner' && group.is_public !== false
}
